import { gql } from "@/__generated__/gql";

export const FEED_POSTS_QUERY = gql(`
  query OrganizationFeedPosts(
    $orgId: ID!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int,
    $status: [FeedPostStatusEnum!],
    $ctaEnabled: Boolean,
    $postedBy: [ID!],
    $ordering: [FeedPostOrderingInput!]
  ) {
    node(id: $orgId) {
      id
      ... on Organization {
        feedPosts(
          first: $first
          last: $last
          after: $after
          before: $before
          status: $status
          ctaEnabled: $ctaEnabled
          postedBy: $postedBy
          ordering: $ordering
        ) {
          edges {
            node {
              id
              name
              ctaUrl
              ctaStudent {
                id
              }
              publishDate
              postedBy {
                id
                firstName
                lastName
                profilePhoto {
                  id
                  url(size: 24)
                }
              }
              views
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          totalCount
        }
      }
    }
  }
`);
